var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 15
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "dk_svg__a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F0F0F0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "dk_svg__b",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#EF264D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E1143C"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#dk_svg__a)",
  d: "M0 0h21v15H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#dk_svg__b)",
  d: "M0 0h21v15H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#dk_svg__a)",
  d: "M0 9h6v6h3V9h12V6H9V0H6v6H0z"
}))));
export { SvgDk as ReactComponent };
export default __webpack_public_path__ + "dd85e682b902ba8eb729707fdc6653b6.svg";